import { END_POINTS } from '../helpers';
import { FuelTypeData, CommonBody } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

type GetFuelTypeResponse = {
  count: number;
  data: FuelTypeData[];
};

export const gccApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getFuelType: builder.query<
      CommonResponse & { data: GetFuelTypeResponse },
      {
        page: number;
        limit: number;
        search: string;
        vehicleId?: string;
      }
    >({
      query: ({ page, limit, search, vehicleId }) => ({
        url: `${END_POINTS.getFuelType}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }${vehicleId ? `&vehicleId=${vehicleId}` : ''}`,
        method: 'GET',
      }),
    }),

    deleteFuelType: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteFuelType}/${id}`,
        method: 'DELETE',
      }),
    }),
    getFuelTypeById: builder.query<CommonResponse & { data: FuelTypeData }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getFuelTypeById}/${id}`,
        method: 'GET',
      }),
    }),

    addFuelType: builder.mutation<CommonResponse & { data: FuelTypeData }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addFuelType}`,
        method: 'POST',
        body,
      }),
    }),
    updateFuelType: builder.mutation<
      CommonResponse & { data: FuelTypeData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateFuelType}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddFuelTypeMutation,
  useUpdateFuelTypeMutation,
  useLazyGetFuelTypeQuery,
  useLazyDeleteFuelTypeQuery,
  useLazyGetFuelTypeByIdQuery,
} = gccApi;
